<template>
  <div class="form-group" 
    v-bind:class="{'required': $attrs.required===''}">
    <label v-if="label" class="control-label">{{ label }}</label>
    <div class="input-group">
      <input
        ref="daterangepicker"
        type="text"
        class="form-control input-daterange-timepicker"
        name="daterange"
        v-bind="$attrs"
        v-on:input="$emit('update:modelValue', $event.target.value)"
        v-bind:value="val"
      />
      <span class="input-group-addon">
        <i class="fa fa-calendar"></i>
      </span>
    </div>
  </div>
</template>
<script>
/* eslint-disable */

import { Delay } from "../../../assets/helpers.js";
export default {
  inheritAttrs: false,
  props: {
    label: String,
    modelValue: String,
    option:Object,
    format:String,
  },
  data() {
    return {
      picker: null,
      val: this.modelValue?.start ?
        this.modelValue.start + ' ~ ' + this.modelValue.end :
        ''
    };
  },
  async mounted() {
    this.picker = $(this.$refs.daterangepicker);
    const format = this.format || 'YYYY-MM-DD';
    await Delay(100);
    const time = {
      startDate: this.modelValue?.start,
      endDate: this.modelValue?.end
    }

    this.picker.daterangepicker({
      ...time,
      timePicker: false,
      autoUpdateInput: false,
      // startDate: moment().subtract(31, 'days').format(format),
      // endDate: moment().format(format),
      // maxDate: moment().format(format),
      locale: {
        format: format,
        applyLabel: '確定',
        cancelLabel: '取消',
        fromLabel : "開始日期",
        toLabel : "結束日期",
        customRangeLabel : "自訂日期區間",
        daysOfWeek : [ "日", "一", "二", "三", "四", "五", "六" ],
        monthNames : [ "1月", "2月", "3月", "4月", "5月", "6月",
        "7月", "8月", "9月", "10月", "11月", "12月" ],
        firstDay : 1
      },
      buttonClasses: ['btn', 'btn-sm'],
      applyClass: 'btn-info',
      cancelClass: 'btn-light'
    }, (start, end) => {
      this.$emit("update:modelValue", {
        start: start.format(format),
        end: end.format(format)
      });
    }).on('apply.daterangepicker', (ev, picker) => {
      this.val = picker.startDate.format(format) + ' ~ ' + picker.endDate.format(format);
    }).on('cancel.daterangepicker', () => {
      this.val = "";
      this.$emit("update:modelValue", {});
    })
  },
  unmounted() {
    this.picker.datepicker('remove')
  },
};

</script>
